<template>
  <v-form>
    <v-row class="ma-0 pa-0 mt-4">
      <v-col
        cols="12"
        v-for="(why, index) in questions"
        :key="`why-${index}`"
        :data-tourId="`problemSolving-5whys-question-${index}`"
        class="mx-0 px-0"
      >
        <v-textarea
          v-model="why.answer"
          rows="1"
          outlined
          dense
          data-private
          auto-grow
          no-resize
          :label="$t('problem_solving.analyse_tool.why_label')"
          :placeholder="getWhyPlaceholder(index)"
          :disabled="!isEditMode"
        >
          <template v-slot:append-outer v-if="isEditMode">
            <v-icon @click="removeWhy(index)">
              mdi-close
            </v-icon>
          </template>
        </v-textarea>
      </v-col>
    </v-row>
    <template v-if="isEditMode">
      <div v-if="!hasReachedWhysLimit" class="text-end">
        <Button
          plain
          color="primary"
          :disabled="!canAddquestions"
          :text="$t('problem_solving.analyse_tool.add_why_button')"
          @click="questions.push({ answer: '' })"
        />
      </div>
      <Alert
        v-else
        :vuetifyProps="{
          value: true,
          color: 'blue',
          icon: 'mdi-information-outline',
        }"
        :text="$t('problem_solving.analyse_tool.maximum_whys_reached_message')"
      />
    </template>
    <v-dialog v-model="showConfirmDialog" persistent max-width="360">
      <v-card>
        <v-card-title>
          {{ $t('problem_solving.analyse_tool.confirm_delete_title') }}
        </v-card-title>
        <v-card-text>
          {{ $t('problem_solving.analyse_tool.confirm_delete_text') }}
        </v-card-text>

        <v-card-actions class="justify-end">
          <Button
            plain
            color="grey"
            :text="$t('common.button.cancel')"
            @click="showConfirmDialog = false"
          />

          <Button
            plain
            color="danger"
            :text="$t('common.button.delete')"
            @click="$emit('removeWhy', 0), $emit('close')"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import Alert from '@/components/Alert.vue'
import Button from '@/components/UI/Button'

export default {
  name: 'QuestionStep',

  props: {
    isEditMode: {
      type: Boolean,
      required: true,
    },
    questions: {
      type: Array,
      required: true,
    },
  },

  components: {
    Alert,
    Button,
  },

  data() {
    return {
      showConfirmDialog: false,
      maxWhysAllowed: this.$constants.problemSolving.maxWhys,
    }
  },

  computed: {
    hasReachedWhysLimit() {
      return this.questions.length === this.maxWhysAllowed
    },

    canAddquestions() {
      const answers = this.questions?.map(why => why?.answer)
      const answersAreFilled = answers?.every(answer =>
        Boolean(answer?.length > 0)
      )

      return answersAreFilled && this.questions.length < this.maxWhysAllowed
    },
  },

  methods: {
    getWhyPlaceholder(index) {
      if (index < 1)
        return this.$t('problem_solving.analyse_tool.why_the_problem_happend')
      return this.$t('problem_solving.analyse_tool.why_the_above_occur')
    },
    removeFirstWhy() {
      this.$emit('removeWhy', 0)
      this.$emit('close')
    },

    removeWhy(index) {
      if (this.questions.length > 1) return this.$emit('removeWhy', index)
      this.showConfirmDialog = true
    },
  },
}
</script>
